module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container push-top"
  }, [(_vm.modules === false) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.modules !== false && _vm.modules.length <= 0) ? _c('div', {
    staticClass: "no-modules"
  }, [_c('img', {
    attrs: {
      "src": "/images/sad.png"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('modules.no_modules_msg_title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('modules.no_modules_msg_body')))]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-primary is-large",
    attrs: {
      "to": "/a/module/new"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('modules.create_module')) + "\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.modules.length > 0) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('router-link', {
    staticClass: "button is-primary is-medium is-pulled-right",
    attrs: {
      "to": "/a/module/new"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('modules.new_module')) + "\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "is-pulled-left"
  }, [_vm._v(_vm._s(_vm.$t('navigation.modules')))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "modules"
  }, [_c('transition-group', {
    attrs: {
      "leave-active-class": "animated zoomOut"
    }
  }, _vm._l((_vm.modules), function(module) {
    return _c('module-line-item', {
      key: module.id,
      attrs: {
        "module": module
      },
      on: {
        "delete": _vm.deleteModule
      }
    })
  }))], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-329b2cc0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Modules.vue
// module id = 519
// module chunks = 0